// This is the only exception to the rule that all types are exported from the types file.
// This is because we want to have coherent error codes and messages.
export enum EApiErrorCode {
	// Format: E_VAGUE_DESCRIPTION_NUMBER
	// API middleware errors
	E_APIMID_0001 = 'E_APIMID_0001', // ZodError in apiMiddleware.server.ts
	E_APIMID_0002 = 'E_APIMID_0002', // Generic error in apiMiddleware.server.ts

	// DbService errors
	E_DB_0001 = 'E_DB_0001', // Generic error in db.service.ts
	E_DB_0002 = 'E_DB_0002', // Conversation not found in db.service.ts
	E_DB_0003 = 'E_DB_0003', // Conversation.data() is null in db.service.ts

	// API Route errors
	E_API_ADD_MESSAGE_0001 = 'E_API_ADD_MESSAGE_0001', // No messages found for conversation / conversation does not exist
	E_API_0003 = 'E_API_0003', // Unauthorized - not logged in
	E_API_0004 = 'E_API_0004', // Forbidden - not owner

	// AiService errors
	E_AI_SERVICE_0001 = 'E_AI_SERVICE_0001', // Schema vector store not initialized properly

	// ConversationAtom errors
	E_CONVERSATION_ATOM_0001 = 'E_CONVERSATION_ATOM_0001', // Conversation is not set

	// Data Source Errors
	E_DATA_SOURCE_INDEXER_001 = 'E_DATA_SOURCE_INDEXER_001', // Generic error in indexer data source.ts

	// Token Limit Errors
	E_TOKEN_LIMIT_EXCEEDED = 'E_TOKEN_LIMIT_EXCEEDED', // User exceeded daily AI token limit

	// Concurrent Request Errors
	E_CONCURRENT_REQUEST_LIMIT = 'E_CONCURRENT_REQUEST_LIMIT', // User has an active request in progress

	// Resume/Interrupt Errors
	E_API_RESUME_0001 = 'E_API_RESUME_0001', // No interrupted message found
	E_API_RESUME_0002 = 'E_API_RESUME_0002', // Question ID mismatch (stale/expired)
	E_API_RESUME_0003 = 'E_API_RESUME_0003' // Invalid option selected
}

export const ERROR_MESSAGES: Record<EApiErrorCode, string> = {
	[EApiErrorCode.E_APIMID_0001]: 'An internal server error occurred.',
	[EApiErrorCode.E_APIMID_0002]: 'An internal server error occurred.',
	[EApiErrorCode.E_DB_0001]: 'An internal server error occurred while retrieving data.',
	[EApiErrorCode.E_DB_0002]: 'Conversation not found.',
	[EApiErrorCode.E_DB_0003]: 'Conversation data not found.',
	[EApiErrorCode.E_API_ADD_MESSAGE_0001]: 'Failed to add message.',
	[EApiErrorCode.E_API_0003]: 'Unauthorized. Please log in.',
	[EApiErrorCode.E_API_0004]: 'Forbidden. You do not have access to this resource.',
	[EApiErrorCode.E_AI_SERVICE_0001]: 'An internal server error occurred while processing user prompt.',
	[EApiErrorCode.E_CONVERSATION_ATOM_0001]: 'Conversation is not set.',
	[EApiErrorCode.E_DATA_SOURCE_INDEXER_001]: 'An internal server error occurred while querying indexer.',
	[EApiErrorCode.E_TOKEN_LIMIT_EXCEEDED]:
		'You have exceeded your AI token limit. Please try again in 12 hours or contact an administrator.',
	[EApiErrorCode.E_CONCURRENT_REQUEST_LIMIT]:
		'You already have an active request in progress. Please wait for it to complete.',
	[EApiErrorCode.E_API_RESUME_0001]: 'No pending interrupt question found in this conversation.',
	[EApiErrorCode.E_API_RESUME_0002]: 'Interrupt question has changed or expired. Please refresh the page.',
	[EApiErrorCode.E_API_RESUME_0003]: 'Invalid option selected.'
} as const;
